import { PremiumProductDetailType } from 'types/global'
import { MapDataTypes } from 'types/map'
import { BriefWalletProductType } from 'types/products'
import { currencySymbolForCurrencyCode } from 'util/misc'

export type WalletProductActivationCatalog =
  | Pick<PremiumProductDetailType, 'id' | 'is_active'>[]
  | null
  | undefined

export const isOrgWalletProductActivated = (
  walletProductId: number | undefined,
  availableProducts: WalletProductActivationCatalog
): boolean => {
  if (!walletProductId) return true
  if (!availableProducts) return false
  return availableProducts.some((product) => product.id === walletProductId && product.is_active)
}

export const isWalletProductActivatedForImageryType = (
  imageryType: MapDataTypes | null | undefined,
  availableProducts: WalletProductActivationCatalog
): boolean => {
  const walletProduct = imageryType?.variation_data?.require_wallet_product
  if (!walletProduct?.id) return true
  if (!walletProduct.activation_requires_permission) return true
  return isOrgWalletProductActivated(walletProduct.id, availableProducts)
}

export const needsWalletProductActivation = (
  imageryType: MapDataTypes | null | undefined,
  availableProducts: WalletProductActivationCatalog
): boolean => {
  if (!imageryType) return false
  const walletProduct = imageryType.variation_data?.require_wallet_product
  if (!walletProduct?.id) return false
  if (!walletProduct.activation_requires_permission) return false
  return !isOrgWalletProductActivated(walletProduct.id, availableProducts)
}

export const formatBriefWalletProductPriceLabel = (
  walletProduct: BriefWalletProductType | undefined
): string | null => {
  if (walletProduct?.unit_price_ex_tax == null || !walletProduct.currency) {
    return null
  }
  const price = Number(walletProduct.unit_price_ex_tax)
  // Free products (e.g. Google Solar API) should not show a $0.00 badge.
  if (!Number.isFinite(price) || price <= 0) {
    return null
  }
  const symbol = currencySymbolForCurrencyCode(walletProduct.currency)
  return `${symbol}${price.toFixed(2)}`
}
